import { Select } from "antd";
import classNames from "classnames";
import Label from "../../Label";

const Simple = ({
  label,
  errors,
  icon,
  touched,
  required,
  direction,
  optional,
  optionFilterProp = "label",
  theme,
  ...rest
}) => {
  return (
    <div
      className={classNames(
        "select__lmf",
        { __error: touched && errors },
        direction,
        theme,
      )}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className={`select__lmf--field`}>
        <Select
          size="large"
          className={classNames({ "disable--input": rest.disabled })}
          optionFilterProp={optionFilterProp}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

export default Simple;
